import { render, staticRenderFns } from "./DataRow.vue?vue&type=template&id=983a2a08&lang=pug&"
import script from "./DataRow.vue?vue&type=script&lang=js&"
export * from "./DataRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports